import { createSlice } from "@reduxjs/toolkit";

const scientificDaySlice = createSlice({
  name: "scientificDays",
  initialState: {
    isFetching: false,
    scientificDays: [],
    error: []
  },
  reducers: {
    statusScientificDayStart: (state) => {
      state.isFetching = false
      state.error = []
    },
    statusScientificDaySuccess: (state, action) => {
      state.isFetching = false
      state.scientificDays = action.payload
      state.error = []
    },
    statusScientificDayFailure: (state, action) => {
      state.isFetching = false
      state.error = action.payload
    }
  }
})


export const { 
  statusScientificDayStart,
  statusScientificDaySuccess,
  statusScientificDayFailure 
} = scientificDaySlice.actions

export default scientificDaySlice.reducer